export default {
  /**
   * 设置应用布局色
   */
  setLayout: layout => ({
    layout
  })
};